<div class="message-container">
  <span>{{ data.message }}</span>
  <ul *ngIf="data.details?.length">
    <li *ngFor="let detail of data.details">{{ detail }}</li>
  </ul>
</div>
<div class="button-wrapper">
  <button mat-button class="mat-button" (click)="dismiss()">
    <span>CLOSE</span>
    <span matRipple></span>
    <span class="mat-button-focus-overlay"></span>
  </button>
</div>
